'use client';

import dynamic from 'next/dynamic';

/**
 * Dialogs are fetched when one first opens, not on page load.
 *
 * `next/dynamic` starts the import when the component *mounts*, so this only pays off if the call
 * site also holds the modal out of the tree until it is wanted — rendering `<Modal open={false}>`
 * downloads the chunk anyway. Each site keeps it mounted from the first open onward, so the
 * dialog's close animation still has something to run on.
 */
export const ContactModal = dynamic(() => import('./contact-modal').then(mod => mod.ContactModal));

export const ScanEmailModal = dynamic(() =>
  import('./scan-email-modal').then(mod => mod.ScanEmailModal),
);
